<template>
  <div id="admin-pickup-points">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <h2>{{$t('Promo Codes')}}</h2>
      </div>
      <div v-if="$store.state.AppActiveUser.userRole === 'growth-hacker'" class="vx-col w-full lg:w-1/2 items-end">
        <div class="flex justify-between">
          <span class="font-semibold"></span>
          <span class="font-medium text-primary cursor-pointer">
            <vs-button
              @click="newPromoCode()"
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              size="large"
            >
            </vs-button>
          </span>
        </div>
      </div>
    </div>
    <promo-exception-table  @type="type = $event" @codeData="promoCode = $event" :promoLoading="promoLoading" @promoAndExceptionModal="promoCodeModal = $event" :currentPage="currentPage" @currentPage="currentPage = $event" :totalRows="totalRows" :data="promoCodes"></promo-exception-table>
    <add-promo-code :type="type" :promoAndExceptionModal="promoCodeModal" @promoAndExceptionModal="promoCodeModal = $event" :data="promoCode" @loadData="loadPromoCodes"></add-promo-code>
  </div>
</template>

<script>
import PromoExceptionTable from './components/PromoAndExceptionTable.vue'
import AddPromoCode from './components/AddPromoCode.vue'
import { sendRequest }  from '../../http/axios/requestHelper.js'

export default {
  data () {
    return {
      promoLoading:false,
      type: '',
      promoCodes: [],
      promoCode: {
        value: 0,
        limits: {
          expiry_date: '',
          per_merchant_cash_value: '',
          per_merchant_usage_count: '',
          start_date: '',
          total_cash_value: '',
          total_usage_count: ''
        },
        qualifier: {
          merchants: [],
          destination_governorates: [],
          package_sizes: [],
          service_levels: [],
          service_types: [],
          subscriptions: []
        },
        threshold: {
          count: 0,
          time_window: ''
        }
      },
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      selected: [],
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      promoCodeModal: false
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadPromoCodes()
    }
  },
  methods: {
    loadPromoCodes () {
      this.promoLoading = true
      sendRequest(true, false, this, `api/v1/discounts/promo-codes/?offset=${this.offset}&limit=${this.maximumItems}`, 'get', null, true,
        (response) => {
          this.promoCodes = response.data.results
          this.totalRows = response.data.count
          this.promoLoading = false
        }
      )
    },
    newPromoCode () {
      this.promoCodeModal = true
      this.type = 'Add'
      this.promoCode = {
        value: 0,
        limits: {
          expiry_date: '',
          per_merchant_cash_value: '',
          per_merchant_usage_count: '',
          start_date: '',
          total_cash_value: '',
          total_usage_count: ''
        },
        qualifier: {
          merchants: [],
          destination_governorates: [],
          package_sizes: [],
          service_levels: [],
          service_types: [],
          subscriptions: []
        },
        threshold: {
          count: 0,
          time_window: ''
        }
      }
    }
  },
  components: {
    AddPromoCode,
    PromoExceptionTable
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadPromoCodes()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>

<style lang="scss">
.con-pagination-table{
  display: none;
}
</style>
